

import { Component, OnInit } from '@angular/core';
import { OrgRole, Permission, Organisation, PermissionService } from '../../../core/services/permission.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
      selector: 'app-role-permission',
      standalone: true,
      imports: [CommonModule, FormsModule],
      templateUrl: './role-permission.component.html'
})
export class RolePermissionComponent implements OnInit {
      // Data State
      permissions: Permission[] = [];
      allRoles: OrgRole[] = [];
      filteredRoles: OrgRole[] = [];
      organisations: Organisation[] = [];

      // Selections
      selectedOrgId: string = '';
      selectedRoleId: string = '';

      // Modal State
      showModal = false;
      newPerm: Permission = { code: '', name: '' };

      constructor(private api: PermissionService) { }

      ngOnInit() {
            this.initData();
      }

      initData() {
            // 1. Load Organisations
            this.api.getOrganisations().subscribe(res => this.organisations = res);

            // 2. Load Permissions List
            this.api.getAll().subscribe(res => {
                  this.permissions = res.map(p => ({ ...p, isAssigned: false }));
            });

            // 3. Load All Roles (to be filtered in browser)
            this.api.getAllRoles().subscribe(res => {
                  this.allRoles = res;
            });
      }

      onOrgChange() {
            this.selectedRoleId = '';
            this.permissions.forEach(p => p.isAssigned = false);

            // Filter roles where orgId matches selection
            this.filteredRoles = this.allRoles.filter(r => r.orgId === this.selectedOrgId);

            // Auto-select first role of that organization
            if (this.filteredRoles.length > 0) {
                  this.selectedRoleId = this.filteredRoles[0].id;
                  this.loadMapping();
            }
      }

      loadMapping() {
            if (!this.selectedRoleId) return;
            this.api.getByRole(this.selectedRoleId).subscribe(assigned => {
                  const assignedIds = assigned.map(a => a.id);
                  this.permissions.forEach(p => p.isAssigned = assignedIds.includes(p.id));
            });
      }

      saveMapping() {
            if (!this.selectedRoleId) {
                  alert('Please select a role first');
                  return;
            }
            const selectedIds = this.permissions.filter(p => p.isAssigned).map(p => p.id!);
            this.api.assign({ roleId: this.selectedRoleId, permissionIds: selectedIds }).subscribe(() => {
                  alert('Permissions assigned successfully!');
            });
      }

      toggleAll(status: boolean) {
            this.permissions.forEach(p => p.isAssigned = status);
      }

      // Modal Logic
      openModal() { this.showModal = true; }
      closeModal() {
            this.showModal = false;
            this.newPerm = { code: '', name: '' };
      }

      createPermission() {
            if (!this.newPerm.code || !this.newPerm.name) return;
            this.api.create(this.newPerm).subscribe(() => {
                  this.initData(); // Refresh list
                  this.closeModal();
            });
      }
}